import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PokerSingleTournamentWidget" */ './PokerSingleTournamentWidget'),
  modules: ['./PokerSingleTournamentWidget'],
  loading: () => <div />
});

export default LoadableWidget;
